import { itTranslation } from './it/translation';

export const resources = {
  it: {
    translation: itTranslation,
  },
};

export default resources;